import type { I18nResources } from 'src/lib/i18n'

import en from './en.json'
import pt from './pt.json'
import de from './de.json'
import fr from './fr.json'
import ru from './ru.json'
import pl from './pl.json'
import es from './es.json'
import sv from './sv.json'
import fi from './fi.json'

const translations: I18nResources = { en, pt, de, fr, ru, pl, es, sv, fi }

export const languages = Object.keys(translations)

export default translations
